import { render, staticRenderFns } from "./withdraw_log.vue?vue&type=template&id=2ef51524"
import script from "./withdraw_log.vue?vue&type=script&lang=js"
export * from "./withdraw_log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports